import React, { useContext, useState } from "react";
import { LoanFormContext } from "./LoanForm";
import FormStep from "../../FormStep";
import { Button, FormGroup } from "react-bootstrap";
import NumberFormat from "react-number-format";
import validator from "validator";

const CombinedAnnualIncome: React.FunctionComponent<{
  onSubmit?: (value: string) => void;
}> = (props: { onSubmit?: (value: string) => void }) => {
  const loanFormContext = useContext(LoanFormContext);
  const [value, setValue] = useState<string>(
    loanFormContext.combinedAnnualIncome
      ? loanFormContext.combinedAnnualIncome.value
      : ""
  );
  const [error, setError] = useState<string>("");

  const handleSubmit = (value: string) => {
    if (validator.isEmpty(value)) {
      setError("Please enter an estimate.");
    } else {
      if (props.onSubmit) {
        props.onSubmit(value);
        setError("");
      }
    }
  };

  return (
    <div>
      <FormStep
        header={
          <h1 className="heading-main">
            What is your combined annual household income?
          </h1>
        }
      >
        <div className="form-inputs-wrapper">
          <FormGroup className="mb-5">
            <NumberFormat
              className="form-control"
              thousandSeparator={true}
              prefix={"$"}
              maxLength={14}
              value={value}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setValue(e.target.value)
              }
            />
            {!error && <div className="hint">(It’s OK to estimate)</div>}
            {error && <div className="hint text-danger">{error}</div>}
          </FormGroup>
          <FormGroup>
            <Button
              variant="primary"
              block
              onClick={() => {
                handleSubmit(value);
              }}
            >
              Continue
            </Button>
          </FormGroup>
        </div>
      </FormStep>
    </div>
  );
};

export default CombinedAnnualIncome;
